import axios from 'axios';
import { currentEnv } from '../config/env';
import { isInternalAuthMode, getInternalToken } from '@/utils/auth-mode';

let authToken: string | null = null;

export const setAuthToken = (token?: string | null) => {
  authToken = token ?? null;
};

const instance = axios.create({
  baseURL: currentEnv.url,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Request interceptor to attach headers centrally
instance.interceptors.request.use(async config => {
  config.headers = config.headers ?? {};

  // Internal auth mode - use token from cookie
  if (isInternalAuthMode()) {
    const token = getInternalToken();
    if (token) {
      (config.headers as Record<string, string>)['Authorization'] = `Bearer ${token}`;
    }
    return config;
  }

  // Auth0 mode: session cookie is sent via withCredentials.
  // Only attach Bearer if we already have a cached token (for initial exchange/fallback).
  if (authToken) {
    (config.headers as Record<string, string>)['Authorization'] = `Bearer ${authToken}`;
  }

  return config;
});

export default instance;
